<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <CCol sm="12">
      <v-row class="my-0">
        <v-col cols="12" md="3" sm="6" class="pl-0 xs-pr-0">
          <label for>Search</label>
          <div class="search-div position-relative">
            <v-text-field name="Search" placeholder="Search" outlined hide-details v-model="search"></v-text-field>
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pb-4 xs-pr-0 xs-pl-0 datepicker">
          <label for class="d-block-mob">Date Range</label>
          <datepicker
            v-model="dateRange"
            @input="dateChange()"
            ref="datepicker"
            :model-config="datePickerConfig"
            :max-date="new Date()"
            is-range
            :masks="{ input: 'DD-MM-YYYY' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control position-relative"
                placeholder="DD-MM-YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetActiveDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </v-col>
        <!-- <v-col cols="12" md="3" sm="6" class="pb-5 mob-p-l-0 xs-pr-0">
          <label for>Role</label>
          <v-select :items="items" outlined hide-details placeholder="Select"></v-select>
        </v-col>-->
        <!-- <v-col cols="12" md="3" class="mob-p-l-0 xs-pr-0">
          <label class="col-sm-12 mb-0 d-none-mob"></label>
          <v-btn class="btn btn-primary">Export</v-btn>
        </v-col>-->
      </v-row>
    </CCol>
    <CCol sm="12" class="px-0">
      <div class="table-div overflow-auto">
        <table class="table userlistTable small-table-width">
          <thead>
            <tr class="table-success">
              <th scope="col">Date</th>
              <!-- <th scope="col">Coupon Code</th> -->
              <th scope="col">User Name</th>
              <th scope="col">Campaign Name</th>
              <th scope="col">Organization</th>
              <!-- <th scope="col">Date of Generation</th> -->
              <th scope="col">Expiry OR Deactivation Date</th>
              <!-- <th scope="col">&#37; Discount OR Amount</th> -->
              <th scope="col">Total Amount</th>
              <th scope="col">Utilized Amount</th>
              <th scope="col">pending Amount</th>
              <!-- <th scope="col">Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="white-space-nowrap">12-02-2021</td>
              <td>
                John Lorem
                <small>Patient</small>
              </td>
              <td>
                Dr Vivika
                <small>Doctor</small>
              </td>
              <td>Lorem Organization</td>
              <td>30-12-2022</td>
              <td>Rs 300</td>
              <td>Rs 100</td>
              <td>Rs 200</td>
              <!-- <td class="action-div small-table-padding">
                <div>
                  <CDropdown color="link" size="lg" :caret="false" class="dropdowndocbox">
                    <template #toggler-content>
                      <verticalDotsSVG />
                    </template>
                    <CDropdownItem></CDropdownItem>
                  </CDropdown>
                </div>
              </td>-->
            </tr>

            <tr>
              <td class="white-space-nowrap">12-02-2021</td>
              <td>
                John Lorem
                <small>Patient</small>
              </td>
              <td>
                Dr Vivika
                <small>Doctor</small>
              </td>
              <td>Lorem Organization</td>
              <td>30-12-2022</td>
              <td>Rs 300</td>
              <td>Rs 100</td>
              <td>Rs 200</td>
              <!-- <td class="action-div small-table-padding">
                <div>
                  <CDropdown color="link" size="lg" :caret="false" class="dropdowndocbox">
                    <template #toggler-content>
                      <verticalDotsSVG />
                    </template>
                    <CDropdownItem></CDropdownItem>
                  </CDropdown>
                </div>
              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </CCol>
  </div>
</template>
<script>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
export default {
  data() {
    return {
      search: "",
      items: ["Doctor", "Vendor", "Centers"],
      dateRange: {
        start: "",
        end: ""
      }
    };
  },
  components: {
    Datepicker,
    ...pickSvg("verticalDotsSVG", "crossSVG", "calendarSVG")
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      // this.searchEntries();
    }
  }
};
</script>